import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getAxios } from '../../../lib/axios';
import { EntityNoteModel } from '../../../globalModels/entityNotes/entityNoteModel';
import { EntityNoteQueryType } from '../../../enums/common/EntityNoteQueryType';
import { CrmEndpoints } from '../../../constants/endpoints/crmEndpoints.ts';

export const useEntityNoteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { id?: number; noteType: EntityNoteQueryType; model: EntityNoteModel }) => {
      vars.model.Id
        ? await getAxios().put(CrmEndpoints.EntityNotes.update(), vars.model)
        : await getAxios().post(CrmEndpoints.EntityNotes.create(vars.noteType, vars.id), vars.model);
      await queryClient.invalidateQueries({
        queryKey: ['entitynotesquery'],
        type: 'all'
      });
    }
  });
};
